import { render, staticRenderFns } from "./TagsButton.vue?vue&type=template&id=33955558&scoped=true"
import script from "./TagsButton.vue?vue&type=script&lang=js"
export * from "./TagsButton.vue?vue&type=script&lang=js"
import style0 from "./TagsButton.vue?vue&type=style&index=0&id=33955558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33955558",
  null
  
)

export default component.exports